var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-stripe" },
    [
      _c("jade-alert", { attrs: { showIcon: "", variant: "neutral" } }, [
        _vm._v(" " + _vm._s(_vm.$t("account.settings.alert.info-edit")) + " "),
      ]),
      _vm.permissionIsEnabled("settings.account.status:view")
        ? _c(
            "status-account",
            {
              attrs: {
                title: _vm.$t("account.settings.statusAccount.title"),
                callback: _vm.saveStatusAccountConfig,
                loading: _vm.getAccountLoading,
                formIsInvalid: _vm.$v.statusAccount.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.account.status:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.statusAccount,
                    _vm.accountSettings.statusAccount
                  )
                },
              },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _c("div", [
                    _c("div", [
                      _c("div", { staticClass: "emd-panel__block" }, [
                        _c("div", { staticClass: "el-chunk" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _color_default _type_caption",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "account.settings.statusAccount.config"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "emd-panel__block" }, [
                        _c("div", [
                          _c("div", { staticClass: "emd-form-group" }, [
                            _c(
                              "label",
                              {
                                staticClass: "emd-label",
                                attrs: { for: "status" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "account.settings.statusAccount.status"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "label",
                              {
                                staticClass: "emd-switcher__label",
                                attrs: {
                                  for: "enabledAccount",
                                  "data-children-count": "1",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.statusAccount.status,
                                      expression: "statusAccount.status",
                                    },
                                  ],
                                  staticClass: "emd-switcher _color_success",
                                  attrs: {
                                    type: "checkbox",
                                    id: "enabledAccount",
                                    "true-value": "active",
                                    "false-value": "inactive",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.statusAccount.status
                                    )
                                      ? _vm._i(_vm.statusAccount.status, null) >
                                        -1
                                      : _vm._q(
                                          _vm.statusAccount.status,
                                          "active"
                                        ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.statusAccount.status,
                                        $$el = $event.target,
                                        $$c = $$el.checked
                                          ? "active"
                                          : "inactive"
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.statusAccount,
                                              "status",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.statusAccount,
                                              "status",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.statusAccount,
                                          "status",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _c("div", {
                                  staticClass: "emd-switcher__area",
                                }),
                                _c(
                                  "span",
                                  { staticClass: "emd-switcher__text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.statusAccount.active"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm.showStatusKyc
                    ? _c("biometry-kyc", {
                        attrs: { status: _vm.lastKyc.kyc_status_reason },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.account.data:view")
        ? _c(
            "shop-config",
            {
              ref: "shopConfig",
              attrs: {
                title: _vm.$t("account.settings.title"),
                callback: _vm.saveAccountConfig,
                loading: _vm.getAccountLoading,
                formIsInvalid: _vm.shopConfigFormIsInvalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.account.data:edit"
                ),
              },
              on: {
                clickEditButton: _vm.$v.account.$touch,
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.account,
                    _vm.accountSettings.account
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.data")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c(
                        "div",
                        { staticClass: "emd-form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "accountName" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("account.settings.name")) +
                                  " "
                              ),
                            ]
                          ),
                          _c("input-disabled", {
                            staticClass: "emd-input",
                            class: {
                              _state_error:
                                _vm.$v.account.name.$invalid &&
                                _vm.$v.account.name.$dirty,
                            },
                            attrs: {
                              id: "accountName",
                              type: "text",
                              autocomplete: "off",
                              name: _vm.$t("account.settings.name"),
                              disabled: !_vm.isGateway,
                            },
                            on: { input: _vm.$v.account.name.$touch },
                            model: {
                              value: _vm.account.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.account, "name", $$v)
                              },
                              expression: "account.name",
                            },
                          }),
                          _vm.$v.account.name.$invalid &&
                          _vm.$v.account.name.$dirty
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _size_small _color_danger eu-mt_1",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("account.settings.hint.length", {
                                          length: "64",
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "emd-form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "accountCorporateName" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.corporate-name")
                                )
                              ),
                            ]
                          ),
                          _c("input-disabled", {
                            staticClass: "emd-input",
                            class: {
                              _state_error:
                                _vm.$v.account.corporate_name.$invalid &&
                                _vm.$v.account.corporate_name.$dirty,
                            },
                            attrs: {
                              id: "accountCorporateName",
                              type: "text",
                              autocomplete: "off",
                              name: _vm.$t("account.settings.corporate-name"),
                              disabled: !_vm.isGateway,
                            },
                            on: { input: _vm.$v.account.corporate_name.$touch },
                            model: {
                              value: _vm.account.corporate_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.account, "corporate_name", $$v)
                              },
                              expression: "account.corporate_name",
                            },
                          }),
                          _vm.$v.account.corporate_name.$invalid &&
                          _vm.$v.account.corporate_name.$dirty
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _size_small _color_danger eu-mt_1",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("account.settings.hint.length", {
                                          length: "64",
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "emd-form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "accountSettingsDocument" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.document"))
                              ),
                            ]
                          ),
                          _c("input-disabled", {
                            staticClass: "emd-input",
                            class: {
                              _state_error:
                                _vm.$v.account.document.$invalid &&
                                _vm.$v.account.document.$dirty,
                            },
                            attrs: {
                              id: "accountSettingsDocument",
                              masked: false,
                              mask: _vm.documentMask,
                              type: "text",
                              name: _vm.$t("account.settings.document"),
                              disabled: !_vm.isGateway,
                            },
                            on: { input: _vm.$v.account.document.$touch },
                            model: {
                              value: _vm.account.document,
                              callback: function ($$v) {
                                _vm.$set(_vm.account, "document", $$v)
                              },
                              expression: "account.document",
                            },
                          }),
                          _vm.$v.account.document.$dirty &&
                          !_vm.$v.account.document.validFormat
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _size_small _color_danger eu-mt_1",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.hint.invalid-document"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.allowed-ips")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.domains-detail")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      !_vm.getAccountLoading && _vm.account
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "div",
                              { staticClass: "emd-form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "domains" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("account.settings.domains"))
                                    ),
                                  ]
                                ),
                                _c("input-tag-domains", {
                                  attrs: {
                                    list: _vm.domains,
                                    disabled: _vm.shopConfigDisabled(),
                                  },
                                  on: { listUpdated: _vm.updateDomains },
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "emd-text _size_small _color_subtle eu-mt_1",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.domains-help.first"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.domains-help.second"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.domains-help.third"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.domains-help.fourth"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.domains-help.fifth"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.ips-detail")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      !_vm.getAccountLoading && _vm.account
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "div",
                              { staticClass: "emd-form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "allowedIps" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("account.settings.ips"))
                                    ),
                                  ]
                                ),
                                _c("input-tag-ips", {
                                  attrs: {
                                    list: _vm.allowedIps,
                                    disabled: _vm.shopConfigDisabled(),
                                    badgeColor: "info",
                                  },
                                  on: { listUpdated: _vm.updateIps },
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "emd-text _size_small _color_subtle eu-mt_1",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.ips-help.first"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.ips-help.second"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.ips-help.third"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.ips-help.fourth"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "account.settings.ips-help.fifth"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.location")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "timezone" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.timezone"))
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              class: {
                                _state_error: _vm.$v.account.time_zone.$invalid,
                              },
                              attrs: { id: "timezone" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.account.time_zone,
                                      expression: "account.time_zone",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.account,
                                        "time_zone",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _vm._l(
                                    _vm.timezones,
                                    function (timezone, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: `timezone-${index}`,
                                          domProps: { value: timezone.key },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(timezone.value) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "currency" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.currency"))
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              class: {
                                _state_error:
                                  _vm.$v.account.default_currency.$invalid,
                              },
                              attrs: { id: "currency" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.account.default_currency,
                                      expression: "account.default_currency",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.account,
                                        "default_currency",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _c("option", { attrs: { value: "BRL" } }, [
                                    _vm._v("BRL"),
                                  ]),
                                ]
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("p", { staticClass: "emd-text _type_caption" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("account.settings.segment-title")) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "segment" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.segment-title"))
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              class: {
                                _state_error:
                                  _vm.$v.account.segment.primary_classification
                                    .$invalid &&
                                  _vm.$v.account.segment.primary_classification
                                    .$dirty &&
                                  !_vm.shopConfigDisabled(),
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.account.segment
                                          .primary_classification,
                                      expression:
                                        "account.segment.primary_classification",
                                    },
                                  ],
                                  attrs: { id: "segment" },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.account.segment,
                                          "primary_classification",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.$v.account.segment
                                        .primary_classification.$touch,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _vm._l(
                                    _vm.getSegmentList,
                                    function (segment, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: `segment-${index}`,
                                          domProps: { value: segment.name },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(segment.name) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                        _vm.account.segment.primary_classification &&
                        _vm.account.segment.primary_classification !== null
                          ? _c("div", { staticClass: "emd-form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "emd-label",
                                  class: {
                                    _required:
                                      !_vm.isTestAccount ||
                                      (_vm.isTestAccount &&
                                        _vm.account.segment
                                          .primary_classification),
                                  },
                                  attrs: { for: "subsegment" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "account.settings.subsegment-title"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "emd-select",
                                  class: {
                                    _state_error:
                                      _vm.$v.account.segment
                                        .secundary_classification.$invalid &&
                                      _vm.$v.account.segment
                                        .secundary_classification.$dirty,
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.account.segment
                                              .secundary_classification,
                                          expression:
                                            "account.segment.secundary_classification",
                                        },
                                      ],
                                      attrs: { id: "subsegment" },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.account.segment,
                                              "secundary_classification",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.$v.account.segment
                                            .secundary_classification.$touch,
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", {
                                        domProps: { value: null },
                                      }),
                                      _vm._l(
                                        _vm.segmentSecundaryList,
                                        function (segment, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: `segment-secundary-${index}`,
                                              domProps: { value: segment.name },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(segment.name) + " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c("div", {
                                    staticClass: "emd-select__arrow",
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("p", { staticClass: "emd-text _type_caption" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("account.settings.integration-title")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: { _required: !_vm.isTestAccount },
                              attrs: { for: "integration" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.integration-title")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              class: {
                                _state_error:
                                  _vm.$v.account.integration.type.$invalid &&
                                  _vm.$v.account.integration.type.$dirty &&
                                  !_vm.shopConfigDisabled(),
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.account.integration.type,
                                      expression: "account.integration.type",
                                    },
                                  ],
                                  attrs: { id: "integration" },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.account.integration,
                                          "type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.$v.account.integration.type.$touch,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _vm._l(
                                    _vm.listFirstItems,
                                    function (integration, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: `integration-first-${index}`,
                                          domProps: {
                                            value: integration.integration_type,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(integration.name) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v(" - ")]
                                  ),
                                  _vm._l(
                                    _vm.listNoDuplicates,
                                    function (integration, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: `integration-no-duplicates-${index}`,
                                          domProps: {
                                            value: integration.integration_type,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                integration.integration_type
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                        _vm.account.integration.type &&
                        _vm.account.integration.type !== null
                          ? _c("div", { staticClass: "emd-form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "emd-label",
                                  class: {
                                    _required:
                                      !_vm.isTestAccount ||
                                      (_vm.isTestAccount &&
                                        _vm.account.integration.type),
                                  },
                                  attrs: { for: "integration-maintainer" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "account.settings.integration-maintainer"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "emd-select",
                                  class: {
                                    _state_error:
                                      _vm.$v.account.integration.maintainer
                                        .$invalid &&
                                      _vm.$v.account.integration.maintainer
                                        .$dirty,
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.account.integration.maintainer,
                                          expression:
                                            "account.integration.maintainer",
                                        },
                                      ],
                                      attrs: { id: "integration-maintainer" },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.account.integration,
                                              "maintainer",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.$v.account.integration.maintainer
                                            .$touch,
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", {
                                        domProps: { value: null },
                                      }),
                                      _vm._l(
                                        _vm.integrationMaintainer,
                                        function (mantainer, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: `mantainer-${index}`,
                                              domProps: {
                                                value: mantainer.name,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(mantainer.name) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c("div", {
                                    staticClass: "emd-select__arrow",
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c("p", { staticClass: "emd-text _type_caption" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("account.settings.address.title")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "address-container" },
                    [
                      _c("emd-address-brazilian-form", {
                        attrs: {
                          searchZipCodeIsAllowed: _vm.canSearchZipCode,
                          fieldsRequired: !_vm.isTestAccount,
                          showSideBlock: false,
                        },
                        on: { formIsValid: _vm.validateAddressForm },
                        model: {
                          value: _vm.account.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.account, "address", $$v)
                          },
                          expression: "account.address",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.showNewCheckout ? _c("settings-checkout") : _vm._e(),
      !_vm.showNewCheckout
        ? [
            _vm.permissionIsEnabled("settings.account.general_data:view")
              ? _c(
                  "general-config",
                  {
                    attrs: {
                      title: _vm.$t("account.settings.general.title"),
                      callback: _vm.saveGeneralConfig,
                      loading: _vm.getAccountLoading,
                      formIsInvalid: _vm.$v.general.$invalid,
                      hideEditButton: !_vm.permissionIsEnabled(
                        "settings.account.general_data:edit"
                      ),
                    },
                    on: {
                      cancelEdit: function ($event) {
                        return _vm.resetObject(
                          _vm.general,
                          _vm.accountSettings.general
                        )
                      },
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", [
                        _c("div", [
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "emd-text _color_default _type_caption",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("account.settings.general.data")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label _required",
                                    attrs: { for: "nameProducts" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.display-name"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.display_name,
                                      expression: "general.display_name",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  class: {
                                    _state_error:
                                      _vm.$v.general.display_name.$invalid,
                                  },
                                  attrs: { id: "nameProducts", type: "text" },
                                  domProps: { value: _vm.general.display_name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.general,
                                        "display_name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _color_nonessential _size_small",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.url-logo-detail"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "urlLogo" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.url-logo"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.logo,
                                      expression: "general.logo",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  class: {
                                    _state_error: _vm.$v.general.logo.$invalid,
                                  },
                                  attrs: { id: "urlLogo", type: "text" },
                                  domProps: { value: _vm.general.logo },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.general,
                                        "logo",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "email" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("account.settings.general.email")
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.email,
                                      expression: "general.email",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  class: {
                                    _state_error: _vm.$v.general.email.$invalid,
                                  },
                                  attrs: { id: "email", type: "text" },
                                  domProps: { value: _vm.general.email },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.general,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        _vm.general.email =
                                          _vm.general.email.toLowerCase()
                                      },
                                    ],
                                  },
                                }),
                              ]),
                            ]),
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "site" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.url-site"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.website,
                                      expression: "general.website",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  class: {
                                    _state_error:
                                      _vm.$v.general.website.$invalid,
                                  },
                                  attrs: { id: "site", type: "text" },
                                  domProps: { value: _vm.general.website },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.general,
                                        "website",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", [
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "emd-text _color_default _type_caption",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.checkout-colors"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _color_nonessential _size_small",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.checkout-colors-detail"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "enableColors" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.default-colors"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-switcher__label",
                                    attrs: { for: "enableColors" },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.general.enableDefaultColors,
                                          expression:
                                            "general.enableDefaultColors",
                                        },
                                      ],
                                      staticClass:
                                        "emd-switcher _color_success",
                                      attrs: {
                                        type: "checkbox",
                                        id: "enableColors",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.general.enableDefaultColors
                                        )
                                          ? _vm._i(
                                              _vm.general.enableDefaultColors,
                                              null
                                            ) > -1
                                          : _vm.general.enableDefaultColors,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a =
                                                _vm.general.enableDefaultColors,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.general,
                                                    "enableDefaultColors",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.general,
                                                    "enableDefaultColors",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.general,
                                                "enableDefaultColors",
                                                $$c
                                              )
                                            }
                                          },
                                          _vm.refreshColors,
                                        ],
                                      },
                                    }),
                                    _c("div", {
                                      staticClass: "emd-switcher__area",
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "emd-switcher__text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.general.active"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _color_nonessential _size_small",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.primary-color-detail"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "mainColor" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.primary-color"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.primary_color,
                                      expression: "general.primary_color",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  attrs: {
                                    disabled: _vm.general.enableDefaultColors,
                                    id: "mainColor",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.general.primary_color,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.general,
                                        "primary_color",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "emd-text _color_nonessential _size_small",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.secondary-color-detail"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "emd-panel__block" }, [
                            _c("div", [
                              _c("div", { staticClass: "emd-form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "emd-label",
                                    attrs: { for: "secondaryColor" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.general.secondary-color"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.general.secondary_color,
                                      expression: "general.secondary_color",
                                    },
                                  ],
                                  staticClass: "emd-input",
                                  attrs: {
                                    disabled: _vm.general.enableDefaultColors,
                                    id: "secondaryColor",
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.general.secondary_color,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.general,
                                        "secondary_color",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.permissionIsEnabled("settings.account.wallet:view")
        ? _c(
            "wallet-config",
            {
              attrs: {
                title: _vm.$t("account.settings.wallet.title"),
                callback: _vm.saveWalletConfig,
                loading: _vm.getAccountLoading,
                formIsInvalid: _vm.$v.wallet.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.account.wallet:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(_vm.wallet, _vm.accountSettings.wallet)
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", [
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.wallet.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.wallet.status-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.wallet.status"))
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledWallet" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.wallet.enabled,
                                    expression: "wallet.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  type: "checkbox",
                                  id: "enabledWallet",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.wallet.enabled)
                                    ? _vm._i(_vm.wallet.enabled, null) > -1
                                    : _vm.wallet.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.wallet.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.wallet,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.wallet,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.wallet, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.wallet.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.wallet.max-cards-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "maxCards" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.wallet.max-cards")
                                )
                              ),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.wallet.max_cards_count,
                                expression: "wallet.max_cards_count",
                              },
                            ],
                            staticClass: "emd-input",
                            class: {
                              _state_error:
                                _vm.$v.wallet.max_cards_count.$invalid,
                            },
                            attrs: { id: "maxCards", type: "text" },
                            domProps: { value: _vm.wallet.max_cards_count },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.wallet,
                                  "max_cards_count",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.wallet.global-wallet"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.wallet.global-wallet-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.wallet.status"))
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledWalletGlobal" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.wallet.shared,
                                    expression: "wallet.shared",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  type: "checkbox",
                                  id: "enabledWalletGlobal",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.wallet.shared)
                                    ? _vm._i(_vm.wallet.shared, null) > -1
                                    : _vm.wallet.shared,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.wallet.shared,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.wallet,
                                            "shared",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.wallet,
                                            "shared",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.wallet, "shared", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.wallet.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }